/**
 * 判断当前环境是否为同花顺PC统一客户端
 * 
 * 通过检测 window.external.createObject 方法来判断是否为同花顺PC统一客户端
 * 
 * @returns {boolean} 如果是同花顺PC统一客户端返回 true，否则返回 false
 * 
 * @example
 * ```ts
 * import { isThsPcTyClient } from '@fu/matrix';
 * 
 * if (isThsPcTyClient()) {
 *   // 在同花顺PC统一客户端中的处理逻辑
 *   console.log('当前在同花顺PC统一客户端中');
 * }
 * ```
 * 
 * @since 1.0.0
 */
export function isThsPcTyClient(): boolean {
  try {
    if (typeof window === 'undefined') {
      return false;
    }
    
    return Boolean(window.external && 'createObject' in window.external);
  } catch (error) {
    console.warn('检测同花顺PC统一客户端失败:', error);
    return false;
  }
}
